import { DocumentListDialog } from '@/components/DocumentListDialog';
import { useGetVendorById } from '@/services/vendorService';
import { useMemo } from 'react';

const VendorDocumentDialog = ({
  vendorId,
  onCloseClick,
  activeIndex = 0,
}: {
  vendorId: string;
  onCloseClick: () => void;
  activeIndex?: number;
}) => {
  const { data: vendorData, isLoading } = useGetVendorById(vendorId);
  const documentList = useMemo(() => {
    return (
      vendorData?.documents.map((document) => ({
        media: document.media!,
        name: document?.name,
      })) ?? []
    );
  }, [vendorData]);

  return (
    <DocumentListDialog
      onCloseClick={onCloseClick}
      activeIndex={activeIndex}
      documents={documentList.reverse()}
      isLoading={isLoading}
    />
  );
};

export default VendorDocumentDialog;
